import { createAction } from '@reduxjs/toolkit';

export const authorizeTokenAction = createAction('user/authorizeTokenAction');
export const conferenceTokenAuthAction = createAction('user/conferenceTokenAuthAction');
export const createUserAction = createAction('user/createUserAction');
export const errorAction = createAction('user/errorAction');
export const getUserAction = createAction('user/getUserAction');
export const guestLoginAction = createAction('user/guestLoginAction');
export const initAction = createAction('user/initAction');
export const initializeConferenceTokenAction = createAction('user/initializeConferenceTokenAction');
export const resetUserAction = createAction('user/resetUserAction');
export const setClassModeAction = createAction('user/setClassModeAction');
export const setUserAction = createAction('user/setUserAction');
export const successAction = createAction('user/successAction');
